/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProposalVote,
    ProposalVoteFromJSON,
    ProposalVoteFromJSONTyped,
    ProposalVoteToJSON,
} from './';

/**
 * 
 * @export
 * @interface GovernanceVotesResponse
 */
export interface GovernanceVotesResponse {
    /**
     * 
     * @type {Array<ProposalVote>}
     * @memberof GovernanceVotesResponse
     */
    list: Array<ProposalVote>;
    /**
     * 
     * @type {number}
     * @memberof GovernanceVotesResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GovernanceVotesResponse
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof GovernanceVotesResponse
     */
    maxPage?: number;
    /**
     * 
     * @type {number}
     * @memberof GovernanceVotesResponse
     */
    totalSize?: number;
}

export function GovernanceVotesResponseFromJSON(json: any): GovernanceVotesResponse {
    return GovernanceVotesResponseFromJSONTyped(json, false);
}

export function GovernanceVotesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GovernanceVotesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ProposalVoteFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'maxPage': !exists(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !exists(json, 'totalSize') ? undefined : json['totalSize'],
    };
}

export function GovernanceVotesResponseToJSON(value?: GovernanceVotesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ProposalVoteToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


